/**
 * 数值区间输入组件，用于 HeaderSearch 中的区间筛选
 * @author zhuyan@372163.com
* @Date: 2025-11-11 16:46:30
 */

import React, { forwardRef } from 'react'
import { Input, InputNumber } from 'antd'
import './RangeNumberInput.scss'

const RangeNumberInput = forwardRef(({ value = [], onChange, placeholderMin = '最小值', placeholderMax = '最大值', min, max, style }, ref) => {
  const [minVal, maxVal] = Array.isArray(value) ? value : []

  const triggerChange = (nextMin, nextMax) => {
    if (typeof onChange === 'function') {
      onChange([nextMin, nextMax])
    }
  }

  return (
    <div ref={ref} className="range-number-input range-number-input--no-controls">
      <Input.Group compact style={style}>
        <InputNumber
          style={{ width: 70, textAlign: 'center' }}
          placeholder={placeholderMin}
          value={minVal}
          onChange={(val) => triggerChange(val, maxVal)}
        />
        <Input
          style={{ width: 30, borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff' }}
          placeholder="~"
          disabled
        />
        <InputNumber
          style={{ width: 70, textAlign: 'center', borderLeft: 0 }}
          placeholder={placeholderMax}
          value={maxVal}
          onChange={(val) => triggerChange(minVal, val)}
        />
      </Input.Group>
    </div>
  )
})

export default RangeNumberInput
